import { useRef, type FC } from "react"
import { Navigate, useParams } from "react-router"
import styled from "styled-components"

import { parseNumber } from "@forento/shared/utilities/number"

import Button from "~/themes/original/components/Button"
import Certificate from "~/themes/original/components/Certificate"
import Layout from "~/themes/original/components/Layout"
import PartialLoadingPage from "~/themes/original/components/PartialLoadingPage"
import { downloadElement } from "~/utilities/element"
import routes from "~/utilities/routes"
import { query } from "~/utilities/trpc"

const CertificatePage: FC = () => {
	const certificateId = parseNumber(useParams().certificateId)

	const downloadRef = useRef<HTMLDivElement>(null)

	const { data: certificate, error } = query.course.certificate.get.useQuery(certificateId ?? -1)

	if (certificate === null) return <Navigate to={routes.certificate.index()} />

	return (
		<Layout>
			{error ? (
				<p>Failed to load certificate.</p>
			) : !certificate ? (
				<PartialLoadingPage />
			) : (
				<>
					<Container ref={downloadRef}>
						<Certificate certificate={certificate} />
					</Container>
					<DownloadButton
						onClick={async () => {
							if (!certificate || !downloadRef.current) return
							await downloadElement(downloadRef.current)
						}}
					>
						Download
					</DownloadButton>
				</>
			)}
		</Layout>
	)
}

const Container = styled.div`
	max-width: 800px;
	background-color: white;
	padding: 24px;
	margin-bottom: 42px;
`

const DownloadButton = styled(Button).attrs({ variant: "primary" })`
	align-self: flex-start;
`

export default CertificatePage
